"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
/* eslint no-redeclare: "off" */
const types_1 = require("@comunica/types");
// TODO: Remove this export, and move test suite to \@comunica/types in the next release
/**
 * @deprecated Logger should be imported from \@comunica/types
 */
const Logger = types_1.Logger;
exports.Logger = Logger;
__exportStar(require("./ActionContext"), exports);
__exportStar(require("./Bus"), exports);
__exportStar(require("./BusIndexed"), exports);
__exportStar(require("./ContextEntries"), exports);
__exportStar(require("./ActionObserver"), exports);
__exportStar(require("./Actor"), exports);
__exportStar(require("./Mediator"), exports);
//# sourceMappingURL=index.js.map